import { ReplaySubject } from 'rxjs';
import { BaseModel } from '../../../../../../core/_base/crud';
import { ViTriNhan, ViTriXuat } from '../../../chuc-nang-kho/phieu-chuyen-kho/phieu-chuyen-kho-model/phieu-chuyen-kho.model';

export class ChuyenKhoNoiBoMaster extends BaseModel{
	static optionsTrangThai = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'CK_DANGSOANTHAO',
		},
		{
			id: 2,
			name: 'Chờ xác nhận',
			value: 'CK_CHOXACNHAN',
		},
		{
			id: 3,
			name: 'Xác nhận 1 phần',
			value: 'CK_XANHAN1PHAN',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'CK_DAXACNHAN',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'CK_DAHUY',
		}
	];
	IdCk: number;
	SoPhieu: string;
	NgayChuyen: string;
	NgayTao: string;
	NguoiTao: number;
	TenNguoitao: string;
	ListNguoiXacNhan: string[];
	TenDSNguoiXacNhan: string[];
	DSNguoiXacNhan: number[];
	TenPhongBan : string;
	PhongBan: number
	listDetail: ChuyenKhoNoiBoDetail[];
	TrangThai: string;
	LyDo: string
	isEnableDuyet: boolean;
	LoaiPhieuIn: string
	clear(){
		this.IdCk = 0;
		this.SoPhieu = '';
		this.NgayChuyen = '';
		this.NgayTao = '';
		this.NguoiTao = 0;
		this.TenNguoitao = '';
		this.ListNguoiXacNhan = []
		this.listDetail = [];
		this.TrangThai = '';
		this.LyDo = ''
		this.isEnableDuyet = false;
		this.LoaiPhieuIn = '';
		this.PhongBan = 0;
		this.DSNguoiXacNhan = [];
	}

	copy(item: ChuyenKhoNoiBoMaster){
		this.IdCk = item.IdCk;
		this.SoPhieu = item.SoPhieu;
		this.NgayChuyen = item.NgayChuyen;
		this.NgayTao = item.NgayTao;
		this.NguoiTao = item.NguoiTao;
		this.TenNguoitao = item.TenNguoitao;
		this.ListNguoiXacNhan = item.ListNguoiXacNhan;
		this.listDetail = item.listDetail;
		this.TrangThai = item.TrangThai;
		this.isEnableDuyet = item.isEnableDuyet;
		this.LyDo = item.LyDo;
		this.LoaiPhieuIn = item.LoaiPhieuIn;
		this.PhongBan = item.PhongBan;
		this.DSNguoiXacNhan = item.DSNguoiXacNhan;
	}
}

export class ChuyenKhoNoiBoDetail {
	IdCtCk: number
	IdDnCk: number
	IdDnCtCk: number
	IdCk: number
	IdHh: number
	IdLo: number
	TenHH: string
	MaHH: string
	IdKhoChuyen: number
	TenKhoChuyen: string
	ViTriKhoChuyen: string
	LotChuyen: number
	SoLo: string
	SoLuongChuyenGoc: number
	SoLuongChuyenQuiDoi: number
	SoLuongNhanGoc: number
	SoLuongNhanQuiDoi: number
	DvtGoc: number
	DvtQuiDoi: number
	TiLeQuiDoi: number
	TenDVTQuiDoi: string
	IdKhoNhan: number
	ViTriKhoNhan: string
	TenKhoNhan: string
	GhiChu: string
	IdTk: number
	SoMay: string
	SoMeSoXe: string
	Ngaysanxuat: string
	Hansudung: string
	MaThung: string 
	listDVTInfo: any[]
	PalletChuyen: string
	PalletNhan: string
	ListKhoChuyen: any[]
	ListViTriChuyen: ViTriXuat[];
	ListViTriNhan: ViTriNhan[];
	ListLOTc: any[];
	filteredLOTC: ReplaySubject<any[]>;
	ListLOTn: any[];
	ListPalletC: any[];
	isError: boolean
	SoPhieuDeNghi: string
	TrangThai: string
	NgayDongThung: string
	NgayDongThungEnabled: boolean
	clear(){
		this.IdCtCk = 0;
		this.IdDnCtCk = null;
		this.IdDnCk = null;
		this.IdCk = 0;
		this.IdHh = 0;
		this.IdLo = 0;
		this.TenHH = '';
		this.MaHH = '';
		this.IdKhoChuyen = 0;
		this.TenKhoChuyen = '';
		this.ViTriKhoChuyen = '';
		this.LotChuyen = 0;
		this.SoLo = '';
		this.SoLuongChuyenGoc = 0;
		this.SoLuongChuyenQuiDoi = 0;
		this.SoLuongNhanQuiDoi = 0;
		this.SoLuongNhanGoc = 0;
		this.DvtGoc = 0;
		this.DvtQuiDoi = 0;
		this.TiLeQuiDoi = 0;
		this.TenDVTQuiDoi = '';
		this.IdKhoNhan = 0;
		this.ViTriKhoNhan = '';
		this.TenKhoNhan = '';
		this.Ngaysanxuat = '';
		this.Hansudung = '';
		this.GhiChu = '';
		this.IdTk = 0;
		this.SoMay = '';
		this.ListKhoChuyen = []
		this.listDVTInfo = [];
		this.ListViTriChuyen = [];
		this.ListViTriNhan = [];
		this.ListLOTc = [];
		this.filteredLOTC = new ReplaySubject<any[]>(1);
		this.ListLOTn = [];
		this.ListPalletC = [];
		this.PalletChuyen = '';
		this.PalletNhan = '';
		this.isError = false;
		this.SoPhieuDeNghi = ''
		this.TrangThai = ''
		this.NgayDongThung = ''
		this.NgayDongThungEnabled = false
	}

	copy(item: ChuyenKhoNoiBoDetail){
		this.IdCtCk = item.IdCtCk;
		this.IdDnCtCk = item.IdDnCtCk;
		this.IdDnCk = item.IdDnCk;
		this.IdCk = item.IdCk;
		this.IdHh = item.IdHh;
		this.TenHH = item.TenHH;
		this.MaHH = item.MaHH;
		this.IdKhoChuyen = item.IdKhoChuyen;
		this.TenKhoChuyen = item.TenKhoChuyen;
		this.ViTriKhoChuyen = item.ViTriKhoChuyen;
		this.LotChuyen = item.LotChuyen;
		this.IdLo = item.IdLo;
		this.SoLo = item.SoLo;
		this.SoLuongChuyenGoc = item.SoLuongChuyenGoc;
		this.SoLuongChuyenQuiDoi = item.SoLuongChuyenQuiDoi;
		this.SoLuongNhanGoc = item.SoLuongNhanGoc;
		this.SoLuongNhanQuiDoi = item.SoLuongNhanQuiDoi
		this.DvtGoc = item.DvtGoc;
		this.DvtQuiDoi = item.DvtQuiDoi;
		this.TiLeQuiDoi = item.TiLeQuiDoi;
		this.TenDVTQuiDoi = item.TenDVTQuiDoi;
		this.IdKhoNhan = item.IdKhoNhan;
		this.ViTriKhoNhan = item.ViTriKhoNhan;
		this.TenKhoNhan = item.TenKhoNhan;
		this.GhiChu = item.GhiChu;
		this.IdTk = item.IdTk;
		this.SoMay = item.SoMay;
		this.listDVTInfo = item.listDVTInfo;
		this.PalletChuyen = item.PalletChuyen;
		this.PalletNhan = item.PalletNhan;
		this.listDVTInfo = item.listDVTInfo;
		this.ListViTriChuyen = item.ListViTriChuyen;
		this.ListViTriNhan = item.ListViTriNhan;
		this.ListLOTc = item.ListLOTc;
		this.ListLOTn = item.ListLOTn;
		this.ListKhoChuyen = item.ListKhoChuyen;
		this.ListPalletC = item.ListPalletC;
		this.SoMay = item.SoMay;
		this.SoMeSoXe = item.SoMeSoXe;
		this.MaThung = item.MaThung;
		this.Ngaysanxuat = item.Ngaysanxuat;
		this.Hansudung = item.Hansudung;
		this.SoPhieuDeNghi = item.SoPhieuDeNghi;
		this.TrangThai = item.TrangThai;
		this.filteredLOTC = item.filteredLOTC
		this.NgayDongThung = item.NgayDongThung;
		this.NgayDongThungEnabled = item.NgayDongThungEnabled;
	}
	
}
export class ConstantsExport {

	// .. Lock đề nghị xuất kho
	public static readonly LOCK_REQCHUYENKHO       = "LOCK_REQCHUYENKHO";
}
